import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { breadcrumbDividerStyles } from 'components/Breadcrumb'
import { ReactComponent as SlashForward } from 'icons/slash.forward.regular-20.svg'
import Navbar from 'components/Navbar'
import { breakpoint } from 'utils'

export const NavigationContainer = styled(Navbar.Section)`
  overflow: hidden;
  width: 100%;
  display: flex;
  margin: 0 12px;

  /* Prevent this section from sending it's siblings of screen
   * https://github.com/sketch-hq/Cloud/issues/1883
   */
  flex-basis: auto;

  ${breakpoint('xs')`
    margin: 0 20px;
  `}
`

export const BreadcrumbWrapper = styled.div`
  width: 100%;
  justify-content: inherit;
  display: flex;
  margin: 0 12px;

  ${breakpoint('xs')`
    margin: 0 20px;
  `}
`

export const BreadcrumbItem = styled.div`
  justify-content: flex-start;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.dark.tertiary};

  &:last-child {
    color: ${({ theme }) => theme.colors.text.dark.base};
  }
`

export const NavigationItemWrapper = styled(NavLink)`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  color: inherit;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.text.dark.secondary};
  }

  &:active {
    color: ${({ theme }) => theme.colors.text.dark.base};
  }
`

export const BreadcrumbDivider = styled(SlashForward)`
  ${breadcrumbDividerStyles}
  top: 1px;
`
